module.exports = __webpack_public_path__ + "vc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/vc.svg
// module id = 876
// module chunks = 0